import { $t } from '@/utils/languageAuto';

var render = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', [_c('h1', {
    staticClass: "pl-20"
  }, [_vm._v(_vm._s(_vm.t('您好，欢迎使用谷仓海外仓')))]), _c('p', {
    staticClass: "pl-20"
  }, [_vm._v(_vm._s(_vm.t('在正式使用谷仓海外仓系统之前，请您先进行签约。')))]), _c('h2', {
    staticClass: "tc p-20"
  }, [_vm._v(_vm._s(_vm.t('请选择企业的注册国家/区域')))]), _c('div', [_c('ul', {
    staticClass: "area-select-box"
  }, [_c('li', {
    staticClass: "area-select-block",
    attrs: {
      "data-permission": "welcome_mainland_submit",
      "id": "welcome_mainland_submit"
    },
    on: {
      "click": function ($event) {
        return _vm.handleChoose('mainland');
      }
    }
  }, [_c('h3', {
    staticClass: "area-select-title"
  }, [_vm._v(_vm._s(_vm.t('中国大陆')))]), _c('p', {
    staticClass: "area-select-desc"
  }, [_vm._v(_vm._s(_vm.t('中国大陆客户需线上签约')))]), _c('ul', [_c('li', {
    staticClass: "area-select-item"
  }, [_c('span', {
    staticClass: "area-select-mark"
  }, [_vm._v("1")]), _vm._v(_vm._s(_vm.t('添加主体')))]), _c('li', {
    staticClass: "area-select-item"
  }, [_c('span', {
    staticClass: "area-select-mark"
  }, [_vm._v("2")]), _vm._v(_vm._s(_vm.t('实名认证')))]), _c('li', {
    staticClass: "area-select-item"
  }, [_c('span', {
    staticClass: "area-select-mark"
  }, [_vm._v("3")]), _vm._v(_vm._s(_vm.t('系统审核')))]), _c('li', {
    staticClass: "area-select-item"
  }, [_c('span', {
    staticClass: "area-select-mark"
  }, [_vm._v("4")]), _vm._v(_vm._s(_vm.t('线上签订合同')))])])]), _c('li', {
    staticClass: "area-select-block ml-30",
    attrs: {
      "data-permission": "welcome_not_mainland_submit",
      "id": "welcome_not_mainland_submit"
    },
    on: {
      "click": function ($event) {
        return _vm.handleChoose('noMainland');
      }
    }
  }, [_c('h3', {
    staticClass: "area-select-title"
  }, [_vm._v(_vm._s(_vm.t('非中国大陆')))]), _c('p', {
    staticClass: "area-select-desc"
  }, [_vm._v(_vm._s(_vm.t('非中国大陆客户线下签约')))]), _c('ul', [_c('li', {
    staticClass: "area-select-item"
  }, [_c('span', {
    staticClass: "area-select-mark"
  }, [_vm._v("1")]), _vm._v(_vm._s(_vm.t('添加主体')))]), _c('li', {
    staticClass: "area-select-item"
  }, [_c('span', {
    staticClass: "area-select-mark"
  }, [_vm._v("2")]), _vm._v(_vm._s(_vm.t('系统审核')))]), _c('li', {
    staticClass: "area-select-item"
  }, [_c('span', {
    staticClass: "area-select-mark"
  }, [_vm._v("3")]), _vm._v(_vm._s(_vm.t('线下签约')))])])])])])]);
};

var staticRenderFns = [];
export { render, staticRenderFns };